<template>
  <div id="goodsList">
    <!-- 商品分类 -->
    <ul class="tab">
      <li @click="tabClick(-1)" :class="tab === -1 ? 'active' : ''">全部</li>

      <li
        @click="tabClick(item.dataValue)"
        :class="tab == item.dataValue ? 'active' : ''"
        v-for="(item, index) in goodsType"
        :key="index"
      >
        {{ item.dataLable }}
      </li>

      <!-- <li @click="tabClick(1)" :class="tab === 1 ? 'active' : ''">视频娱乐</li>
      <li @click="tabClick(2)" :class="tab === 2 ? 'active' : ''">美食生活</li> -->
    </ul>
    <!-- 商品列表 -->
    <!-- <ul class="list">
      <li class="item" v-for="i in 1" :key="i" @click="toDetail(i)">
        <div class="img-box">
          <img src="@/static/images/home/pic_list.png" />
        </div>
        <div class="info">
          <div class="title">
            <p>标准洗车保养标准洗车（奥体店）</p>
          </div>
          <p class="code">33333趣豆</p>
          <p class="times">3333次查看</p>
        </div>
      </li>
    </ul> -->
    <!-- 下拉加载更多 -->
    <ul
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      class="list"
    >
      <li
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="img-box">
          <img :src="host + item.goodsPhoto" />
          <!-- <img src="@/static/images/home/pic_list.png" /> -->
        </div>
        <div class="info">
          <div class="title">
            <p>{{ item.name }}</p>
          </div>
          <p class="code">{{ item.score }}趣豆</p>
          <!-- <p class="times">{{item.name}}次查看</p> -->
        </div>
      </li>
      <li>
        <div class="loading" v-show="loading">
          <mt-spinner type="fading-circle"></mt-spinner>
          <p>加载中...</p>
        </div>
        <div class="loading" v-show="loadAll">
          <p>已加载全部</p>
        </div>
      </li>
    </ul>
    <NoData v-show="noData" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      tab: "1", //全部'' 车务服务0 视频娱乐1 美食生活2 （商品类型）
      loading: false,
      loadAll: false,
      noData: false,
      list: [],
      pageNo: "1",
      pageSize: "10",
    };
  },
  mounted() {
    this.tab = this.$route.params.id;
    this.queryGoodsList();
  },
  methods: {
    tabClick(n) {
      this.scrollTop();
      setTimeout(() => {
        this.tab = n;
        this.$router.push({ name: "GoodsList", params: { id: n } });
        this.loading = false;
        this.loadAll = false;
        this.noData = false;
        this.list = [];
        this.pageNo = "1";
        this.pageSize = "10";
        this.queryGoodsList();
      }, 200);
    },
    toDetail(item) {
      this.$router.push({ name: "GoodsDetail", params: { id: item.id } });
    },
    loadMore() {
      if (this.loadAll) {
        return;
      }
      this.loading = true;
      this.pageNo++;
      this.queryGoodsList(() => {
        this.loading = false;
      });
    },
    // 查询商品列表接口
    queryGoodsList(fn) {
      let goodsType = this.tab == -1 ? "" : this.tab;
      this.post(this.apis.queryGoodsList, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        goodsType,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            if (fn) {
              fn();
            }

            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapState(["goodsType"]),
  },
};
</script>

<style lang="less" scoped>
#goodsList {
  .tab {
    padding: 28px 30px 10px;
    display: flex;
    position: fixed;
    background-color: #fff;
    width: 700px;
    justify-content: space-between;
    li {
      &::first-child {
        width: 112px;
      }
      height: 54px;
      border-radius: 4px;
      border: solid 1px #1fbe6e;
      line-height: 54px;
      text-align: center;
      margin-right: 16px;
      padding: 0 24px;
      color: #283349;
      &.active {
        background-color: #1fbe6e;
        color: #ffffff;
      }
    }
  }
  .list {
    padding: 120px 30px 0;
    margin: 0 auto;
    .item {
      width: 691px;
      height: 218px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 26px;
      .img-box {
        flex: 0 0 187px;
        height: 170px;
        display: flex;
        align-items: center;
        margin-left: 18px;
        margin-right: 24px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .info {
        height: 186px;
        .title {
          padding-top: 24px;
          height: 72px;
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: #3a3a3a;
          font-size: 30px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          /** 对象作为伸缩盒子模型显示 **/
          -webkit-box-orient: vertical;
          /** 设置或检索伸缩盒对象的子元素的排列方式 **/
          -webkit-line-clamp: 2;
          /** 显示的行数 **/
          overflow: hidden;
          /** 隐藏超出的内容 **/
        }
        .code {
          font-family: PingFang-SC-Bold;
          font-size: 32px;
          color: #1fbe6e;
        }
        .times {
          padding-top: 10px;
          font-family: PingFang-SC-Regular;
          font-size: 22px;
          text-align: right;
          color: #3a3a3a;
          padding-right: 20px;
        }
      }
    }
  }
}
</style>
